import { Loader2 } from "lucide-react";

interface Props {
  /** Tamaño en pixels */
  size?: number;
  /** Texto opcional al lado */
  label?: string;
  className?: string;
}

export function Spinner({ size = 20, label, className = "" }: Props) {
  return (
    <div
      className={[
        "inline-flex items-center gap-2 text-dgl-text-muted",
        className,
      ].join(" ")}
      role="status"
      aria-live="polite"
    >
      <Loader2
        className="animate-spin text-dgl-primary"
        style={{ width: size, height: size }}
      />
      {label && <span className="text-small">{label}</span>}
    </div>
  );
}

/** Centrado vertical y horizontal en el contenedor padre. */
export function FullSpinner({ label = "Cargando…" }: { label?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[200px] w-full">
      <Spinner size={28} label={label} />
    </div>
  );
}
